import { useCallback, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { readItems } from "@directus/sdk";

export function useLoans(vendor) {
  const [loans, setLoans] = useState([]);
  const [loadingLoans, setLoadingLoans] = useState(false);

  const getLoans = useCallback(async () => {
    if (!vendor || !vendor.id) {
      setLoans([]);
      return;
    }
    setLoadingLoans(true);
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("prestamos_tropas", {
          filter: {
            vendedor: { _eq: vendor.id },
            tipo: { _eq: "prestamo_tropas" },
            estado: { _eq: "activo" },
          },
          fields: [
            "id",
            "tipo",
            "estado",
            "vendedor",
            "inventario_nsp.*",
            "inventario_nsp.inventario_ns_prestamo_id.*",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.*",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.producto.*",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.producto.grupo.impuesto",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.producto.preciosinimp",
            "seriales.seriales_id.*",
            "seriales.seriales_id.producto.*",
            "seriales.seriales_id.producto.grupo.impuesto"
          ],
          sort: ["-date_created"],
        })
      );
      setLoans(response);
    } catch (error) {
      setLoans([]);
    } finally {
      setLoadingLoans(false);
    }
  }, [vendor]);

  return { loans, loadingLoans, getLoans };
}
